export enum BusinessEntityActionKeys {
  ADD_BUSINESS_ENTITY_ADDRESSES = 'ADD_BUSINESS_ENTITY_ADDRESSES',
  ADD_BUSINESS_ENTITY_CONTACTS = 'ADD_BUSINESS_ENTITY_CONTACTS',
  ADD_BUSINESS_ENTITY_NAMES = 'ADD_BUSINESS_ENTITY_NAMES',
  ADD_BUSINESS_ENTITY_SALESCALLS = 'ADD_BUSINESS_ENTITY_SALESCALLS',
  DISABLE_LOADING_CONTACTS = 'DISABLE_LOADING_CONTACTS',
  DISABLE_LOADING_SALESCALLS = 'DISABLE_LOADING_SALESCALLS',
  FETCH_BE_MIN_DETAILS = 'FETCH_BE_MIN_DETAILS',
  REMOVE_BUSINESS_ENTITY_CONTACT = 'REMOVE_BUSINESS_ENTITY_CONTACT',
  REMOVE_BUSINESS_ENTITY_SALESCALL = 'REMOVE_BUSINESS_ENTITY_SALESCALL',
  SAVE_BUSINESS_ENTITY_ADDRESS = 'SAVE_BUSINESS_ENTITY_ADDRESS',
  SAVE_BUSINESS_ENTITY_ADDRESS_FULFILLED = 'SAVE_BUSINESS_ENTITY_ADDRESS_FULFILLED',
  SAVE_BUSINESS_ENTITY_ADDRESS_REJECTED = 'SAVE_BUSINESS_ENTITY_ADDRESS_REJECTED',
  SEARCH_BUSINESS_ENTITIES = 'SEARCH_BUSINESS_ENTITIES',
  SET_BE_ADDRESSES = 'SET_BE_ADDRESSES',
  SET_BE_COMPETITORS = 'SET_BE_COMPETITORS',
  SET_BE_MARKET_SEGMENTS = 'SET_BE_MARKET_SEGMENTS',
  SET_BE_MIN_DETAILS = 'SET_BE_MIN_DETAILS',
  SET_BE_PRODUCT_CATEGORIES = 'SET_BE_PRODUCT_CATEGORIES',
  SET_BE_RANK_TYPE = 'SET_BE_RANK_TYPE',
  SET_BE_SALESCALL_TOTAL = 'SET_BE_SALESCALL_TOTAL',
  SET_BE_SEARCH_RESULTS = 'SET_BE_SEARCH_RESULTS',
  SET_LOADED_CONTACTS = 'SET_LOADED_CONTACTS',
  SET_LOADED_SALESCALLS = 'SET_LOADED_SALESCALLS',
  SET_LOADING_CONTACTS = 'SET_LOADING_CONTACTS',
  SET_LOADING_SALESCALLS = 'SET_LOADING_SALESCALLS',
  TOGGLE_BE_SEARCH_LOADING = 'TOGGLE_BE_SEARCH_LOADING',
  UPDATE_BE_COMPETITORS = 'UPDATE_BE_COMPETITORS',
  UPDATE_BE_MARKET_SEGMENTS = 'UPDATE_BE_MARKET_SEGMENTS',
  UPDATE_BE_PRODUCT_CATEGORIES = 'UPDATE_BE_PRODUCT_CATEGORIES',
  UPDATE_BE_RANK_TYPE = 'UPDATE_BE_RANK_TYPE'
}
